import { consoleError } from "@utils/console";

function isCssColor(color) {
  return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
}

export default {
  name: "colorable",

  props: {
    color: String
  },

  methods: {
    setBackgroundColor(color, data = {}) {
      if (typeof data.style === "string") {
        consoleError("style must be an object", this);
        return data;
      }
      if (typeof data.class === "string") {
        consoleError("class must be an object", this);
        return data;
      }
      if (isCssColor(color)) {
        data.style = {
          ...data.style,
          "background-color": `${color}`,
          "border-color": `${color}`
        };
      } else if (color) {
        data.class = {
          ...data.class,
          [color]: true
        };
      }

      return data;
    },

    setTextColor(color, data = {}) {
      if (typeof data.style === "string") {
        consoleError("style must be an object", this);
        return data;
      }
      if (typeof data.class === "string") {
        consoleError("class must be an object", this);
        return data;
      }
      if (isCssColor(color)) {
        data.style = {
          ...data.style,
          color: `${color}`,
          "caret-color": `${color}`
        };
      } else if (color) {
        const [colorName, colorModifier] = color
          .toString()
          .trim()
          .split(" ", 2);
        data.class = {
          ...data.class,
          [colorName + "_text"]: true
        };
        if (colorModifier) {
          data.class["text_" + colorModifier] = true;
        }
      }
      return data;
    }
  }
};
